<template>
    <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_612_2572)">
            <path
                d="M0 4.8C0 2.5368 -7.15256e-08 1.4064 0.7032 0.7032C1.4064 -7.15256e-08 2.5368 0 4.8 0C7.0632 0 8.1936 -7.15256e-08 8.8968 0.7032C9.6 1.4064 9.6 2.5368 9.6 4.8V19.2C9.6 21.4632 9.6 22.5936 8.8968 23.2968C8.1936 24 7.0632 24 4.8 24C2.5368 24 1.4064 24 0.7032 23.2968C-7.15256e-08 22.5936 0 21.4632 0 19.2V4.8ZM14.4 4.8C14.4 2.5368 14.4 1.4064 15.1032 0.7032C15.8064 -7.15256e-08 16.9368 0 19.2 0C21.4632 0 22.5936 -7.15256e-08 23.2968 0.7032C24 1.4064 24 2.5368 24 4.8V19.2C24 21.4632 24 22.5936 23.2968 23.2968C22.5936 24 21.4632 24 19.2 24C16.9368 24 15.8064 24 15.1032 23.2968C14.4 22.5936 14.4 21.4632 14.4 19.2V4.8Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_612_2572">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg> -->
    <!-- <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_612_2572)">
            <path
                d="M0.75 4.8C0.75 3.64718 0.751595 2.85837 0.831204 2.26659C0.907892 1.69654 1.0444 1.42266 1.23353 1.23353C1.42266 1.0444 1.69654 0.907892 2.26659 0.831204C2.85837 0.751595 3.64718 0.75 4.8 0.75C5.95282 0.75 6.74163 0.751595 7.33341 0.831204C7.90346 0.907892 8.17734 1.0444 8.36647 1.23353C8.5556 1.42266 8.69211 1.69654 8.7688 2.26659C8.8484 2.85837 8.85 3.64718 8.85 4.8V19.2C8.85 20.3528 8.8484 21.1416 8.7688 21.7334C8.69211 22.3035 8.5556 22.5773 8.36647 22.7665C8.17734 22.9556 7.90346 23.0921 7.33341 23.1688C6.74163 23.2484 5.95282 23.25 4.8 23.25C3.64718 23.25 2.85837 23.2484 2.26659 23.1688C1.69654 23.0921 1.42266 22.9556 1.23353 22.7665C1.0444 22.5773 0.907892 22.3035 0.831204 21.7334C0.751595 21.1416 0.75 20.3528 0.75 19.2V4.8ZM15.15 4.8C15.15 3.64718 15.1516 2.85837 15.2312 2.26659C15.3079 1.69654 15.4444 1.42266 15.6335 1.23353C15.8227 1.0444 16.0965 0.907892 16.6666 0.831204C17.2584 0.751595 18.0472 0.75 19.2 0.75C20.3528 0.75 21.1416 0.751595 21.7334 0.831204C22.3035 0.907892 22.5773 1.0444 22.7665 1.23353C22.9556 1.42266 23.0921 1.69654 23.1688 2.26659C23.2484 2.85837 23.25 3.64718 23.25 4.8V19.2C23.25 20.3528 23.2484 21.1416 23.1688 21.7334C23.0921 22.3035 22.9556 22.5773 22.7665 22.7665C22.5773 22.9556 22.3035 23.0921 21.7334 23.1688C21.1416 23.2484 20.3528 23.25 19.2 23.25C18.0472 23.25 17.2584 23.2484 16.6666 23.1688C16.0965 23.0921 15.8227 22.9556 15.6335 22.7665C15.4444 22.5773 15.3079 22.3035 15.2312 21.7334C15.1516 21.1416 15.15 20.3528 15.15 19.2V4.8Z"
                stroke="currentColor"
                stroke-width="1.5"
            />
        </g>
        <defs>
            <clipPath id="clip0_612_2572">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg> -->
    <svg
        viewBox="0 0 30 30"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27Z"
            fill="currentColor"
        />
        <path
            d="M13.3333 10.6364C13.3333 9.73263 12.5871 9 11.6667 9C10.7462 9 10 9.73263 10 10.6364V19.3636C10 20.2674 10.7462 21 11.6667 21C12.5871 21 13.3333 20.2674 13.3333 19.3636V10.6364Z"
            fill="currentColor"
        />
        <path
            d="M20 10.6364C20 9.73263 19.2538 9 18.3333 9C17.4129 9 16.6667 9.73263 16.6667 10.6364V19.3636C16.6667 20.2674 17.4129 21 18.3333 21C19.2538 21 20 20.2674 20 19.3636V10.6364Z"
            fill="currentColor"
        />
    </svg>
</template>
